import styled from 'styled-components';

import { THead } from 'components/Table';

export const AnimationTableHead = styled(THead)`
  position: sticky;
  top: 0;
  background-color: white;
  z-index: 1;
`;
